import PropTypes from "prop-types";
import React from "react";
import "./Alert.css";
import Heading from "./Heading";
import Icon from "./Icon";

function giveActionColor(action) {
	switch (action) {
		case "primary": {
			return "var(--blue-8)";
		}
		case "secondary": {
			return "var(--gray-9)";
		}
		case "success": {
			return "var(--green-9";
		}
		case "info": {
			return "var(--cyan-9)";
		}
		case "warning": {
			return "var(--yellow-8)";
		}
		case "danger": {
			return "var(--red-9)";
		}
		case "light": {
			return "var(--gray-7)";
		}
		case "dark": {
			return "var(--black)";
		}
		default: {
			return "var(--black)";
		}
	}
}

function giveActionIcon(action) {
	switch (action) {
		case "success": {
			return "checkmark-outline";
		}
		case "danger": {
			return "exclamation-outline";
		}
		default: {
			return "information-outline";
		}
	}
}

const Alert = (props) => {
	const { action, heading, children, className } = props;

	return (
		<div className={`alert alert-${action} ${className}`} role="alert">
			<Icon
				shape={giveActionIcon(action)}
				size={25}
				style={{ fill: giveActionColor(action) }}
			/>
			<div className="alert-container ml-3">
				{heading && (
					<Heading type={4} size={18} className="alert-heading mt-0 mb-2">
						{heading}
					</Heading>
				)}
				{children}
			</div>
		</div>
	);
};

Alert.propTypes = {
	heading: PropTypes.string,
	children: PropTypes.oneOfType([
		PropTypes.node,
		PropTypes.arrayOf(PropTypes.node)
	]).isRequired,
	action: PropTypes.oneOf([
		"primary",
		"secondary",
		"success",
		"danger",
		"warning",
		"dark",
		"light",
		"info"
	]).isRequired,
	className: PropTypes.string
};

Alert.defaultProps = {
	heading: "",
	className: ""
};

export default Alert;
